var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9793 6.91711L8.97933 17.9171C8.88352 18.0132 8.76968 18.0895 8.64433 18.1416C8.51898 18.1936 8.38459 18.2204 8.24886 18.2204C8.11313 18.2204 7.97874 18.1936 7.85339 18.1416C7.72804 18.0895 7.6142 18.0132 7.51839 17.9171L2.70589 13.1046C2.60996 13.0087 2.53387 12.8948 2.48196 12.7695C2.43004 12.6441 2.40332 12.5098 2.40332 12.3741C2.40332 12.2385 2.43004 12.1041 2.48196 11.9788C2.53387 11.8535 2.60996 11.7396 2.70589 11.6437C2.80182 11.5477 2.9157 11.4717 3.04103 11.4197C3.16637 11.3678 3.3007 11.3411 3.43636 11.3411C3.57202 11.3411 3.70635 11.3678 3.83169 11.4197C3.95702 11.4717 4.0709 11.5477 4.16683 11.6437L8.24972 15.7266L18.5201 5.45789C18.7138 5.26416 18.9766 5.15532 19.2506 5.15532C19.5246 5.15532 19.7873 5.26416 19.981 5.45789C20.1748 5.65162 20.2836 5.91438 20.2836 6.18836C20.2836 6.46234 20.1748 6.72509 19.981 6.91883L19.9793 6.91711Z",
    fill: "#00022A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.daffc5c5f1287c8fe1173cc3a9b622e3.svg";
export { ForwardRef as ReactComponent };